import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CategoryModule } from '../../appshared/invoice/category/category.module';
import { CategoryService } from '../../appshared/invoice/category/category.service';

@Component({
  selector: 'app-navlink',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule],
  templateUrl: './navlink.component.html',
  styleUrl: './navlink.component.css',
})
export class NavlinkComponent {
  private menuOpen = false;
  ComID: number = 1;
  currentLang: string = localStorage.getItem('locale') || 'en';
  public dataSourceCategory: CategoryModule[] = [];

  constructor(
    private serv: CategoryService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.currentLang = localStorage.getItem('locale') || 'en';

    this.translate.use(this.currentLang);

  //  this.FillCategory();
  }

  toggleMenu() {
    const menu = document.getElementById('navbarNav');
    if (menu) {
      menu.classList.toggle('show');
      this.menuOpen = !this.menuOpen;
    }
  }

  //FillCategory() {
  //  this.serv.getService(this.ComID, 'Item').subscribe(
  //    (res: CategoryModule[]) => {
  //      this.dataSourceCategory = res;

  //      // Log content conditionally based on language
  //      this.dataSourceCategory.forEach((item) => {
  //        // console.log(this.currentLang === 'ar' ? item.nameAr : item.name);
  //      });
  //    },
  //    (err: any) => {
  //      console.error(err);
  //    }
  //  );
  //}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const menu = document.getElementById('navbarNav');
    const button = document.querySelector('.navbar-toggler');
    if (menu && button && this.menuOpen) {
      const target = event.target as HTMLElement;
      if (!menu.contains(target) && !button.contains(target)) {
        menu.classList.remove('show');
        this.menuOpen = false;
      }
    }
  }
}
